import { useQuery } from '@tanstack/react-query';
import { campaignsClient } from 'clients/CampaignsClient/CampaignsClient';
import { queryClient } from 'config/queryClient';
import { useRef } from 'react';
import { QueryKey } from 'types/query';

export const useGetCampaignNewRepliesQuery = () => {
  const previousCountRef = useRef(0);
  const isFirstFetch = useRef(true);
  return useQuery(
    [QueryKey.useGetCampaignNewRepliesQuery],
    async () => {
      const { data } = await campaignsClient.getCampaignNewReplies();

      return data.new_replies;
    },
    {
      refetchInterval: 30_000,
      refetchIntervalInBackground: true,
      initialData: 0,
      initialDataUpdatedAt: 0,
      onSuccess: (newCount) => {
        if (isFirstFetch.current) {
          isFirstFetch.current = false;
        } else if (newCount !== previousCountRef.current) {
          queryClient.invalidateQueries([QueryKey.useCandidateHistoryQuery], { exact: false });
          queryClient.invalidateQueries([QueryKey.useGetUnreadConversationsAmount], { exact: false });
          queryClient.invalidateQueries([QueryKey.campaignManagerContextUseCampaigns], { exact: false });
          queryClient.invalidateQueries([QueryKey.useCandidateActivityLogQuery], { exact: false });
          queryClient.invalidateQueries([QueryKey.getInfiniteConversations], { exact: false, refetchType: 'none' });
        }

        previousCountRef.current = newCount;
      },
    },
  );
};
